import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDealershipSettings } from 'services/DealershipSettings/selectors';
import { BrandingTypes } from 'services/resources';
import { intercom } from 'utils';

export default function IntercomProvider({ children }: { children: React.ReactNode }) {
  const brandingType: BrandingTypes = useSelector(selectDealershipSettings()).brandingType;

  useEffect(() => {
    if (brandingType === 'fleetlane') {
      intercom.boot();
    } else {
      intercom.shutdown();
    }
  }, [brandingType]);

  return <>{children}</>;
}
